export const GET_MEAL_BY_ID = 'NUTRITION/GET_MEAL_BY_ID';
export const SET_MEAL = 'NUTRITION/SET_MEAL';
export const GET_MEAL_PLAN = 'NUTRITION/GET_MEAL_PLAN';
export const SET_MEAL_PLAN = 'NUTRITION/SET_MEAL_PLAN';
export const SET_LOADING_STATE = 'NUTRITION/SET_LOADING_STATE';
